module.exports = __webpack_public_path__ + "img/Murmeli4.d4d12f3e.gif";